<script>
import { mapGetters } from "vuex";
import Panel from "./Panel";

export default {
  components: { Panel },
  computed: {
    ...mapGetters(["isMaster", "getResultados"])
  }
};
</script>

<template>
  <div v-if="isMaster" class="resultados">
    <panel v-for="resultado in getResultados" :key="resultado.codigo" :resultado="resultado"></panel>
  </div>
</template>
